"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTMInit = void 0;
var react_1 = __importDefault(require("react"));
var GTMInit = function (_a) {
    var gtmID = _a.gtmID;
    return (react_1.default.createElement("noscript", null,
        react_1.default.createElement("iframe", { src: "https://www.googletagmanager.com/ns.html?id=".concat(gtmID), height: "0", width: "0", style: { display: 'none', visibility: 'hidden' } })));
};
exports.GTMInit = GTMInit;
